export class ControllerBase {

    constructor() {

    }

}